export const errorTranslation = (error: string): string => 
  error in errorTranslations ? errorTranslations[error] : error;
  
const errorTranslations: {[error:string]: string} = {
  "Invalid login credentials": 'Email ou senha inválidos',
  "captcha protection: request disallowed (no captcha_token found)": 'Verificação de segurança falhou. Por favor, tente novamente.',
  "captcha protection: request disallowed (timeout-or-duplicate)": 'Verificação de segurança expirada. Por favor, tente novamente.'
}